import { ProductInternalResponseDto, ProductNodeDto, ProductSearchResultDto, SubstanceDTO } from '@scip/api';
import { ProductNodeIdentifier } from '../../services';

export class ProductUtils {
  private static SUBSTANCE_DIVIDER = '__SUB__';

  /**
   * returns all identifiers as string array from a productDto array provided
   * @returns string array of product identifiers
   */
  static getIdentifiersForProducts(products: Array<ProductInternalResponseDto | ProductSearchResultDto>): string[] {
    const productIdentifiers: string[] = [];
    for (let i = 0; i <= products.length - 1; i++) {
      if (products[i].lockedForUpdate === false || products[i].lockedForUpdate === undefined) {
        productIdentifiers.push(products[i].identifier);
      }
    }
    return productIdentifiers;
  }

  static copyProducts(origin: ProductNodeDto): ProductNodeDto {
    return JSON.parse(JSON.stringify(origin));
  }

  static getProductNodeDtoIdentifier(productNode: ProductNodeDto): ProductNodeIdentifier {
    return productNode.identifier + productNode.orderId;
  }
  static getSubstanceNodeIdentifier(substance: SubstanceDTO, parentProduct: ProductNodeDto): string {
    return ProductUtils.getProductNodeDtoIdentifier(parentProduct) + ProductUtils.SUBSTANCE_DIVIDER + substance.casNumber;
  }

  static isSubstanceIdentifier(identifier: string): boolean {
    return identifier.includes(ProductUtils.SUBSTANCE_DIVIDER);
  }

  static getProductNodeIdentifierForSubstance(identifier: string): ProductNodeIdentifier {
    return identifier.substring(0, identifier.indexOf(ProductUtils.SUBSTANCE_DIVIDER));
  }

  static getOnlySubstanceIdentifier(identifier: string): string {
    return identifier.split(ProductUtils.SUBSTANCE_DIVIDER).pop();
  }

  static getSubstanceOfProductNode(productNode: ProductNodeDto, substanceIdentifier: string): SubstanceDTO {
    return productNode.substances.find((singleSubstance) => singleSubstance.casNumber === substanceIdentifier);
  }
}
